import clsx from 'clsx'
import { Dispatch, SetStateAction } from 'react'

import { ISearchResponse } from '@/_types/search'

import { useHeaderLinks } from '../../_hooks'
import ACallCenter from '../a-call-center'
import { AHeaderOrderOnlineZLink } from '../a-header-order-online-z-link'
import ALogo from '../a-logo'

import ADesktopSearch from './a-desktop-search'
import AHeaderDesktopLinks from './a-header-desktop-links'

export default function ADesktopHeaderTop({
	onLinkClick,
	topHeaderStyle,
	searchOpen,
	setSearchOpen,
	searchQuery,
	onSearchQueryChange,
	onSearchClose,
	searchData,
	isSearchLoading,
	isSearching,
	hasSearchTerm
}: {
	onLinkClick: () => void
	topHeaderStyle: 'normal' | 'transparent'
	searchOpen: boolean
	setSearchOpen: Dispatch<SetStateAction<boolean>>
	searchQuery: string
	onSearchQueryChange: (query: string) => void
	onSearchClose: () => void
	searchData: ISearchResponse | undefined
	isSearchLoading: boolean
	isSearching: boolean
	hasSearchTerm: boolean
}) {
	const { mainLinks } = useHeaderLinks()

	return (
		<div
			className={clsx('desktop-header__top', {
				'desktop-header__top--white': topHeaderStyle === 'normal',
				'desktop-header__top--search-active': searchOpen
			})}
		>
			<div className='desktop-header__top-content'>
				<div className='desktop-header__top-left'>
					<ALogo onLinkClick={onLinkClick} />
				</div>

				<div className='desktop-header__top-right'>
					<AHeaderDesktopLinks
						links={mainLinks}
						onLinkClick={onLinkClick}
						className={clsx('desktop-header__top-links', {
							'desktop-header__top-links--hidden': searchOpen
						})}
					/>

					<ADesktopSearch
						searchOpen={searchOpen}
						setSearchOpen={setSearchOpen}
						searchQuery={searchQuery}
						onSearchQueryChange={onSearchQueryChange}
						onSearchClose={onSearchClose}
						searchData={searchData}
						isSearchLoading={isSearchLoading}
						isSearching={isSearching}
						hasSearchTerm={hasSearchTerm}
						onLinkClick={onLinkClick}
					/>

					<ACallCenter />

					<AHeaderOrderOnlineZLink
						href='/volne-terminy'
						title='Objednajte sa'
						className='btn_basic type4 !ml-[8px]'
						onClick={onLinkClick}
						prefetch={true}
					>
						<span>
							Objednajte sa<span className='hide_xlm'> online</span>
						</span>
						<span className='inline-block min-w-[30px]'>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar3_r' />
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar3_r' />
								</svg>
							</span>
						</span>
					</AHeaderOrderOnlineZLink>
				</div>
			</div>
		</div>
	)
}
